import { render, staticRenderFns } from "./ArchivoPacientes.vue?vue&type=template&id=6e84a440&"
import script from "./ArchivoPacientes.vue?vue&type=script&lang=js&"
export * from "./ArchivoPacientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports